import NotFound from 'components/NotFound';

import Dashboard from 'routes/Dashboard';
import ChangePassword from 'routes/AccountPasswordPage';
import UserProfilePage from 'routes/AccountProfilePage';
import OrderEditPage from 'routes/OrderEditPage';
import OrderListPage from 'routes/OrderListPage';
import PackageListPage from 'routes/PackageListPage';
import PackageEditPage from 'routes/PackageEditPage';
import PackageDateEditPage from 'routes/PackageDateEditPage';
import FlightListPage from 'routes/FlightListPage';
import FlightEditPage from 'routes/FlightEditPage';
import HotelListPage from 'routes/HotelListPage';
import HotelEditPage from 'routes/HotelEditPage';
import RoomEditPage from 'routes/RoomEditPage';

import ContentPage from 'routes/ContentPage';
import ContentMenuPage from 'routes/ContentMenuPage';
import ContentMenuEditPage from 'routes/ContentMenuEditPage';
import ContentMenuItemEditPage from 'routes/ContentMenuItemEditPage';
import ContentPageListPage from 'routes/ContentPageListPage';
import ContentPageEditPage from 'routes/ContentPageEditPage';
import ContentWhatToSeeListPage from 'routes/ContentWhatToSeeListPage';
import ContentWhatToSeeEditPage from 'routes/ContentWhatToSeeEditPage';
import ContentPoiListPage from 'routes/ContentPoiListPage';
import ContentPoiEditPage from 'routes/ContentPoiEditPage';
import SeoRouteListPage from 'routes/SeoRouteListPage';
import SeoRouteEditPage from 'routes/SeoRouteEditPage';

import UserListPage from 'routes/UserListPage';
import UserEditPage from 'routes/UserEditPage';
import ToolsPage from 'routes/ToolsPage';
import ToolsDiskCleanupPage from 'routes/ToolsDiskCleanupPage';
import ToolsHotelImportsPage from 'routes/ToolsHotelImportsPage';

import SettingsPage from 'routes/SettingsPage';
import SettingsGeneralPage from 'routes/SettingsGeneralPage';
import SettingsCateringListPage from 'routes/SettingsCateringListPage';
import SettingsCateringEditPage from 'routes/SettingsCateringEditPage';
import SettingsCountryListPage from 'routes/SettingsCountryListPage';
import SettingsCountryEditPage from 'routes/SettingsCountryEditPage';
import SettingsRegionEditPage from 'routes/SettingsRegionEditPage';
import SettingsCityEditPage from 'routes/SettingsCityEditPage';
import SettingsLabelListPage from 'routes/SettingsLabelListPage';
import SettingsLabelEditPage from 'routes/SettingsLabelEditPage';
import SettingsCategoryListPage from 'routes/SettingsCategoryListPage';
import SettingsCategoryEditPage from 'routes/SettingsCategoryEditPage';
import SettingsDepartureLocationListPage from 'routes/SettingsDepartureLocationListPage';
import SettingsDepartureLocationEditPage from 'routes/SettingsDepartureLocationEditPage';
import SettingsRoomPropertyListPage from 'routes/SettingsRoomPropertyListPage';
import SettingsRoomPropertyEditPage from 'routes/SettingsRoomPropertyEditPage';
import SettingsServiceGroupListPage from 'routes/SettingsServiceGroupListPage';
import SettingsServiceGroupEditPage from 'routes/SettingsServiceGroupEditPage';
import SettingsServiceEditPage from 'routes/SettingsServiceEditPage';
import SettingsServiceOptionEditPage from 'routes/SettingsServiceOptionEditPage';
import SettingsTermListPage from 'routes/SettingsTermListPage';
import SettingsTermEditPage from 'routes/SettingsTermEditPage';
import SettingsIntegrationsPage from 'routes/SettingsIntegrationsPage';
import SettingsTravelDocumentListPage from 'routes/SettingsTravelDocumentListPage';
import SettingsTravelDocumentEditPage from 'routes/SettingsTravelDocumentEditPage';

export const ROUTES = [
  {
    index: true,
    element: <Dashboard />,
  },
  {
    path: 'account',
    children: [
      { path: 'profile', element: <UserProfilePage /> },
      { path: 'password', element: <ChangePassword /> },
    ],
  },
  {
    path: 'orders',
    children: [
      { index: true, element: <OrderListPage /> },
      { path: ':id', element: <OrderEditPage /> },
    ],
  },
  {
    path: 'packages',
    children: [
      { index: true, element: <PackageListPage /> },
      { path: ':id', element: <PackageEditPage /> },
    ],
  },
  {
    path: 'package-dates',
    children: [{ path: ':id', element: <PackageDateEditPage /> }],
  },
  {
    path: 'flights',
    children: [
      { index: true, element: <FlightListPage /> },
      { path: ':id', element: <FlightEditPage /> },
    ],
  },
  {
    path: 'hotels',
    children: [
      { index: true, element: <HotelListPage /> },
      { path: ':id', element: <HotelEditPage /> },
    ],
  },
  {
    path: 'rooms',
    children: [{ path: ':id', element: <RoomEditPage /> }],
  },
  {
    path: 'content',
    children: [
      { index: true, element: <ContentPage /> },
      {
        path: 'menu',
        children: [
          { index: true, element: <ContentMenuPage /> },
          { path: ':id', element: <ContentMenuEditPage /> },
        ],
      },
      {
        path: 'menu-items',
        children: [{ path: ':id', element: <ContentMenuItemEditPage /> }],
      },
      {
        path: 'pages',
        children: [
          { index: true, element: <ContentPageListPage /> },
          { path: ':id', element: <ContentPageEditPage /> },
        ],
      },
      {
        path: 'what-to-sees',
        children: [
          { index: true, element: <ContentWhatToSeeListPage /> },
          { path: ':id', element: <ContentWhatToSeeEditPage /> },
        ],
      },
      {
        path: 'pois',
        children: [
          { index: true, element: <ContentPoiListPage /> },
          { path: ':id', element: <ContentPoiEditPage /> },
        ],
      },
    ],
  },
  {
    path: 'seo',
    children: [
      { index: true, element: <SeoRouteListPage /> },
      { path: ':id', element: <SeoRouteEditPage /> },
    ],
  },
  {
    path: 'users',
    children: [
      { index: true, element: <UserListPage /> },
      { path: ':id', element: <UserEditPage /> },
    ],
  },
  {
    path: 'tools',
    children: [
      { index: true, element: <ToolsPage /> },
      { path: 'disk-cleanup', element: <ToolsDiskCleanupPage /> },
      { path: 'hotel-imports', element: <ToolsHotelImportsPage /> },
    ],
  },
  {
    path: 'settings',
    children: [
      { index: true, element: <SettingsPage /> },
      { path: 'general', element: <SettingsGeneralPage /> },
      {
        path: 'countries',
        children: [
          { index: true, element: <SettingsCountryListPage /> },
          { path: ':id', element: <SettingsCountryEditPage /> },
        ],
      },
      {
        path: 'regions',
        children: [{ path: ':id', element: <SettingsRegionEditPage /> }],
      },
      {
        path: 'cities',
        children: [{ path: ':id', element: <SettingsCityEditPage /> }],
      },
      {
        path: 'labels',
        children: [
          { index: true, element: <SettingsLabelListPage /> },
          { path: ':id', element: <SettingsLabelEditPage /> },
        ],
      },
      {
        path: 'categories',
        children: [
          { index: true, element: <SettingsCategoryListPage /> },
          { path: ':id', element: <SettingsCategoryEditPage /> },
        ],
      },
      {
        path: 'catering',
        children: [
          { index: true, element: <SettingsCateringListPage /> },
          { path: ':id', element: <SettingsCateringEditPage /> },
        ],
      },
      {
        path: 'departure-locations',
        children: [
          { index: true, element: <SettingsDepartureLocationListPage /> },
          { path: ':id', element: <SettingsDepartureLocationEditPage /> },
        ],
      },
      {
        path: 'room-properties',
        children: [
          { index: true, element: <SettingsRoomPropertyListPage /> },
          { path: ':id', element: <SettingsRoomPropertyEditPage /> },
        ],
      },
      {
        path: 'service-groups',
        children: [
          { index: true, element: <SettingsServiceGroupListPage /> },
          { path: ':id', element: <SettingsServiceGroupEditPage /> },
        ],
      },
      {
        path: 'services',
        children: [{ path: ':id', element: <SettingsServiceEditPage /> }],
      },
      {
        path: 'service-options',
        children: [{ path: ':id', element: <SettingsServiceOptionEditPage /> }],
      },
      {
        path: 'terms',
        children: [
          { index: true, element: <SettingsTermListPage /> },
          { path: ':id', element: <SettingsTermEditPage /> },
        ],
      },
      {
        path: 'travel-documents',
        children: [
          { index: true, element: <SettingsTravelDocumentListPage /> },
          { path: ':id', element: <SettingsTravelDocumentEditPage /> },
        ],
      },
      { path: 'integrations', element: <SettingsIntegrationsPage /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];
